import {
    NinchatActionType,
    NinchatDeleteMasterKeyAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'

import {NinchatMasterKeyDeletedEvent} from 'api/types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const deleteMasterKey = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDeleteMasterKeyAction}`,
    async (arg: NinchatActionParams<NinchatDeleteMasterKeyAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDeleteMasterKeyAction

        try {
            return await ninchatClient.send(params) as NinchatMasterKeyDeletedEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
